// extracted by css-extract-rspack-plugin
export default {"add_content":"add_content___7yIzJ"};